export default "__VITE_ASSET__f_rsoNUG__"